export default __webpack_public_path__ + "static/nellie-recommends-e5e135ba01dee39c908947391f02a8e6.svg";